<template>
  <div>
    <div class="t_search_box t_conbox">
      <img
        src="@/assets/img/dwhc.png"
        style="position: absolute; height: 22px; top: 27px; left: 34px"
      >
      <div>
        <el-input
          v-model="search.shtyxydm"
          class="t_search_input"
          placeholder="请输入完整的统一社会信用代码"
        />
        <el-input
          v-model="search.dwmc"
          class="t_search_input"
          placeholder="请输入完整的单位名称"
        />
        <el-button
          v-preventReClick
          class="t_hcbtn"
          type="primary"
          @click="hcfunc"
        >核查</el-button>
      </div>
    </div>
    <div v-if="xxshow" style="margin-top: 20px">
      <qyjbxx :qyarray="qyarray" :dwhcpd="dwhcpd" />
    </div>
  </div>
</template>

<script>
// 获取接口地址
import qyjbxx from '@/components/qyjbxx/qyjbxx1'
import { getDwhc } from '@/assets/js/xxhc'

export default {
  name: 'Dwhc',
  components: {
    qyjbxx
  },
  data() {
    return {
      dwhcpd: true,
      xxshow: false,
      search: {
        dwmc: '',
        shtyxydm: ''
      },
      qyarray: {}
    }
  },
  created: function() {
    // //获取企业信息
    // this.getinfo()
  },
  methods: {
    getinfo() {
      getDwhc({
        dwmc: this.search.dwmc, // 许可证编号
        shtyxydm: this.search.shtyxydm // 核查结束时间
      })
        .then((e) => {
          this.qyarray = e.data.data
          this.dwhcpd = false
          this.xxshow = true
        })
        .catch((e) => {
          this.xxshow = false
        })
    },
    hcfunc() {
      this.getinfo()
    }
  }
}
</script>

<style scoped>
.t_conbox {
  width: 95%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
}
.t_search_box {
  background-color: white;
  padding: 27px 34px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.t_search_input {
  width: 300px;
  margin-right: 20px;
}
.t_search_input /deep/.el-input__inner {
  background-color: #fff;
}
.t_hcbtn {
  background-color: #4170ff;
  border: none;
}
</style>
